module.exports = __webpack_public_path__ + "img/add_box.e3510c55.svg";